export const initialState = {
    signalMap: {},
    signalsList: [],
    companySharePrice: {},
    financialData: [],
    criticalFactorsList: [],
    filteredCriticalFactors: {
        equityFactors: [],
        creditFactors: [],
        cloversFactors: [],
    },
    stockConsensusGraphData: [],
    shareRatioGraphData: {},
    degreeView: [],
    epsData: {},
    companySpecificSignal: [],
    impactData: [],
    networkGraphData: [],
    correctId: null,
    companyAnalystData: {},
    activeRic: '',
    showChatBot: false,
    analystStatus: false,
    showNotifications: [],
    activeRicValue: '',
};
